import { Row, Col, Typography, Space, Divider } from 'antd';

const { Title, Text, Paragraph, Link } = Typography;

export function Footer() {
  return (
    <footer
      style={{
        padding: '64px 24px 32px 24px',
        backgroundColor: '#001529',
        color: 'rgba(255, 255, 255, 0.65)',
      }}
    >
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <Row gutter={[32, 48]}>
          {/* Logo Column */}
          <Col xs={24} md={6}>
            <Space align="center" size="small" style={{ marginBottom: '16px' }}>
              <img
                src="/logo-icon.png"
                alt="iSubscribe"
                width="28"
                height="28"
              />
              <Text strong style={{ fontSize: '20px', color: '#7c3aed' }}>
                iSubscribe
              </Text>
            </Space>
            <Paragraph
              style={{
                color: 'rgba(255, 255, 255, 0.65)',
                fontSize: '14px',
                lineHeight: 1.5,
              }}
            >
              Complete subscription infrastructure for modern SaaS.
            </Paragraph>
          </Col>

          {/* Products Column */}
          <Col xs={12} md={6}>
            <Title
              level={5}
              style={{
                color: '#ffffff',
                marginBottom: '20px',
                fontSize: '15px',
              }}
            >
              Products
            </Title>
            <Space
              orientation="vertical"
              size="small"
              style={{ width: '100%' }}
            >
              <Link
                href="#features"
                style={{ color: 'rgba(255, 255, 255, 0.65)' }}
              >
                Features
              </Link>
              <Link href="#docs" style={{ color: 'rgba(255, 255, 255, 0.65)' }}>
                API Documentation
              </Link>
              <Link
                href="#pricing"
                style={{ color: 'rgba(255, 255, 255, 0.65)' }}
              >
                Pricing
              </Link>
              <Link
                href="#security"
                style={{ color: 'rgba(255, 255, 255, 0.65)' }}
              >
                Security
              </Link>
            </Space>
          </Col>

          {/* Resources Column */}
          <Col xs={12} md={6}>
            <Title
              level={5}
              style={{
                color: '#ffffff',
                marginBottom: '20px',
                fontSize: '15px',
              }}
            >
              Resources
            </Title>
            <Space
              orientation="vertical"
              size="small"
              style={{ width: '100%' }}
            >
              <Link href="#docs" style={{ color: 'rgba(255, 255, 255, 0.65)' }}>
                Documentation
              </Link>
              <Link
                href="#guides"
                style={{ color: 'rgba(255, 255, 255, 0.65)' }}
              >
                Guides
              </Link>
              <Link href="#sdks" style={{ color: 'rgba(255, 255, 255, 0.65)' }}>
                SDKs
              </Link>
            </Space>
          </Col>

          {/* Company Column */}
          <Col xs={12} md={6}>
            <Title
              level={5}
              style={{
                color: '#ffffff',
                marginBottom: '20px',
                fontSize: '15px',
              }}
            >
              Company
            </Title>
            <Space
              orientation="vertical"
              size="small"
              style={{ width: '100%' }}
            >
              <Link
                href="#about"
                style={{ color: 'rgba(255, 255, 255, 0.65)' }}
              >
                About
              </Link>
              <Link
                href="#contact"
                style={{ color: 'rgba(255, 255, 255, 0.65)' }}
              >
                Contact
              </Link>
              <Link
                href="#privacy"
                style={{ color: 'rgba(255, 255, 255, 0.65)' }}
              >
                Privacy
              </Link>
              <Link
                href="#terms"
                style={{ color: 'rgba(255, 255, 255, 0.65)' }}
              >
                Terms
              </Link>
            </Space>
          </Col>
        </Row>

        <Divider
          style={{
            borderColor: 'rgba(255, 255, 255, 0.1)',
            margin: '40px 0 24px 0',
          }}
        />

        <div
          style={{
            textAlign: 'center',
            fontSize: '13px',
            color: 'rgba(255, 255, 255, 0.45)',
          }}
        >
          © 2026 iSubscribe. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
